import {
    MOBILE_SIDEBAR_OPEN,
    MOBILE_SIDEBAR_CLOSE,
    SCREEN_RESIZE
} from "../types";


export function openMobileSidebar() {
    return {
        type: MOBILE_SIDEBAR_OPEN
    };
}

export function closeMobileSidebar() {
    return {
        type: MOBILE_SIDEBAR_CLOSE
    };
}

export function screenResize(width) {
    return {
        type: SCREEN_RESIZE,
        payload: width
    };
}


// WEBPACK FOOTER //
// ./src/actions/mobile_actions/index.js